import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/settings/notifications")({
  head: () => ({ meta: [{ title: "Notifications | Settings" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-settings-notifications")),
});
